import styled from 'styled-components';
import {BGImageCenter, BLACK, dFlex} from '../../../../../globalVariables/GlobalVariables';
import {dFlexEnd, flexColumn} from '../../../../../globalVariables/GlobalFlex';
import {arrowDark} from '../../../../../assets/symbols/symbols/Symbols.css';
import {close, title as popTitle, bottom, content} from '../../../../../component/newPopup/innerPop/InnerPop.css';

export const wrapPopup = styled.div`
    ${popTitle}{
        color: ${BLACK}
    }
    ${close}{
        ${BGImageCenter(arrowDark,'16px')}
    }
    ${content}{
        height: calc(100% - 110px);
        width: 100%;
    }
    ${bottom} {
        gap: 10px;
        ${dFlexEnd};
        padding-inline-end: 20px;
    }
`;
export const committeesList = styled.div`
    ${dFlex}
    ${flexColumn}
    margin-block-start: 40px;
    padding: 20px;
`;
